import React from 'react';
import {
  Dialog,
  DialogContent,
} from '@/components/ui/dialog';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ImagePalette } from '@/extensions/color-palette/ColorSwatches';

interface ImageLightboxProps {
  url: string;
  alt?: string;
  isOpen: boolean;
  onClose: () => void;
}

export function ImageLightbox({ url, alt, isOpen, onClose }: ImageLightboxProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-[90vw] max-h-[90vh] p-0 border-none bg-black/90">
        <Button
          variant="ghost"
          size="icon"
          className="absolute top-4 right-4 text-white hover:bg-white/20 z-50"
          onClick={onClose}
        >
          <X className="h-6 w-6" />
        </Button>
        
        <div className="flex flex-col items-center justify-center gap-3 p-4">
          <img
            src={url}
            alt={alt || 'Image'}
            className="max-w-full max-h-[80vh] object-contain rounded-lg"
          />
          <ImagePalette url={url} size={28} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
